import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from 'styles';

import AutoComplete from 'material-ui/AutoComplete';
import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';

import api from 'services';
import MapComponent from './Map';
import constants from 'constants';

class MergingAreas extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sourceObject: {
                name: '',
            },
            sourceItems: [],

            destinationObject: {
                name: '',
            },
            destinationItems: [],
        };

        this.onUpdateInput = this.onUpdateInput.bind(this);
        this.onChooseAutoComplete = this.onChooseAutoComplete.bind(this);
        this.merge = this.merge.bind(this);
        this.join = this.join.bind(this);
        this.add = this.add.bind(this);
    }

    merge() {
        this.props.mergeAreas();
    }

    join() {
        this.props.joinAreas();
    }

    add() {
        this.props.addAreaToArea();
    }

    updateInputSource(searchText) {
        const sourceObject = { name: searchText };

        this.setState({
            sourceObject,
        }, () => {
            this.props.addValue('sourceArea', sourceObject);

            if (searchText.length <= 1) {
                return;
            }

            api.findPortAdmin({ name: searchText, onlyAreasWithChild: true })
                .then((response) => {
                    if (response.status === 200) {
                        const sourceItems = [];

                        response.data.data.forEach((item) => {
                            sourceItems.push({
                                name: `${item.name} ${item.country ? `(${item.country.name})` : ''}`,
                                item: (<MenuItem
                                    style={{ width: '100%' }}
                                    primaryText={`${item.name} ${item.country ? `(${item.country.name})` : ''}`}
                                    item={item}
                                />),
                            });

                            if (item.alt && item.alt.length > 0) {
                                item.alt.forEach((alternativeName) => {
                                    sourceItems.push({
                                        name: `${alternativeName} (alternative name)`,
                                        item: (<MenuItem
                                            style={{ width: '100%', padding: '0 0 0 20px' }}
                                            primaryText={`${alternativeName} (alternative name)`}
                                            item={item}
                                        />),
                                    });
                                });
                            }


                            if (item.sub && item.sub.length > 0) {
                                item.sub.forEach((subPort) => {
                                    sourceItems.push({
                                        name: `${subPort.name} ${item.country ? `(${item.country.name})` : ''}`,
                                        item: (<MenuItem
                                            style={{ width: '100%', padding: '0 0 0 20px' }}
                                            primaryText={`${subPort.name} ${item.country ? `(${item.country.name})` : ''}`}
                                            item={subPort}
                                        />),
                                    });
                                });
                            }
                        });

                        this.setState({
                            sourceItems,
                        }, () => {
                            document.body.scrollTop = document.body.scrollTop + 1;
                            document.body.scrollTop = document.body.scrollTop - 1;
                        });
                    }
                });
        });
    }

    updateInputDestination(searchText) {
        const destinationObject = { name: searchText };

        this.setState({
            destinationObject,
        }, () => {
            this.props.addValue('destinationArea', {});

            if (searchText.length <= 1) {
                return;
            }

            api.findPortAdmin({ name: searchText, onlyAreasWithChild: true })
                .then((response) => {
                    if (response.status === 200) {
                        const destinationItems = [];

                        response.data.data.forEach((item) => {
                            destinationItems.push({
                                name: `${item.name} ${item.country ? `(${item.country.name})` : ''}`,
                                item: (<MenuItem
                                    style={{ width: '100%' }}
                                    primaryText={`${item.name} ${item.country ? `(${item.country.name})` : ''}`}
                                    item={item}
                                />),
                            });

                            if (item.alt && item.alt.length > 0) {
                                item.alt.forEach((alternativeName) => {
                                    destinationItems.push({
                                        name: `${alternativeName} (alternative name)`,
                                        item: (<MenuItem
                                            style={{ width: '100%', padding: '0 0 0 20px' }}
                                            primaryText={`${alternativeName} (alternative name)`}
                                            item={item}
                                        />),
                                    });
                                });
                            }

                            if (item.sub && item.sub.length > 0) {
                                item.sub.forEach((subPort) => {
                                    destinationItems.push({
                                        name: `${subPort.name} ${item.country ? `(${item.country.name})` : ''}`,
                                        item: (<MenuItem
                                            style={{ width: '100%', padding: '0 0 0 20px' }}
                                            primaryText={`${subPort.name} ${item.country ? `(${item.country.name})` : ''}`}
                                            item={subPort}
                                        />),
                                    });
                                });
                            }
                        });

                        this.setState({
                            destinationItems,
                        }, () => {
                            document.body.scrollTop = document.body.scrollTop + 1;
                            document.body.scrollTop = document.body.scrollTop - 1;
                        });
                    }
                });
        });
    }

    onUpdateInput(searchText, type) {
        switch (type) {
        case 'source':
            this.updateInputSource(searchText);
            break;
        case 'destination':
            this.updateInputDestination(searchText);
            break;
        }
    }

    onChooseSource(updateProperties) {
        if (typeof updateProperties === 'string' && this.state.sourceItems.length > 0) {
            let { sourceObject } = this.state;
            sourceObject = this.state.sourceItems[0].item.props.item;

            this.setState({
                sourceObject,
                sourceItems: [],
            }, () => {
                this.props.addValue('sourceArea', sourceObject);
            });

            return;
        }

        if (!updateProperties || typeof updateProperties === 'string') {
            return;
        }

        let { sourceObject } = this.state;
        sourceObject = updateProperties.item.props.item;

        this.setState({
            sourceObject,
            sourceItems: [],
        }, () => {
            this.props.addValue('sourceArea', sourceObject);
        });
    }

    onChooseDestination(updateProperties) {
        if (typeof updateProperties === 'string' && this.state.destinationItems.length > 0) {
            let { destinationObject } = this.state;
            destinationObject = this.state.destinationItems[0].item.props.item;

            this.setState({
                destinationObject,
                destinationItems: [],
            }, () => {
                this.props.addValue('destinationArea', destinationObject);
            });

            return;
        }

        if (!updateProperties || typeof updateProperties === 'string') {
            return;
        }

        let { destinationObject } = this.state;
        destinationObject = updateProperties.item.props.item;

        this.setState({
            destinationObject,
            destinationItems: [],
        }, () => {
            this.props.addValue('destinationArea', destinationObject);
        });
    }

    onChooseAutoComplete(updateProperties, type) {
        switch (type) {
        case 'source':
            this.onChooseSource(updateProperties);
            break;
        case 'destination':
            this.onChooseDestination(updateProperties);
            break;
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.clearAreas) {
            return this.setState({
                sourceObject: {
                    name: '',
                },
                sourceItems: [],

                destinationObject: {
                    name: '',
                },
                destinationItems: [],
            });
        }

        this.setState({
            sourceObject: nextProps.sourceArea,
        });
    }

    render() {
        const {
            sourceObject,
            sourceItems,
            destinationObject,
            destinationItems,
        } = this.state;

        const { disabledBtn, disabledAddAreaToArea } = this.props;

        return (
            <div>
                <div className="row">
                    <h3 className='col-xs-3'>
                        Merge area to area
                    </h3>
                </div>
                <div className="row">
                    <div className='col-xs-4'>
                        <p style={{ fontSize: '12px' }}>
                            Auto Complete only areas (Search fields are name, alt name). <br />
                            Area doesn't have country field.
                        </p>
                        <AutoComplete
                            textFieldStyle={styles.autoCompleteCSS}
                            floatingLabelText='Source'
                            searchText={sourceObject.name}
                            dataSource={sourceItems}
                            dataSourceConfig={{ text: 'name', value: 'item' }}
                            onUpdateInput={(searchText) => { this.onUpdateInput(searchText, 'source'); }}
                            onNewRequest={(chosenRequest) => { this.onChooseAutoComplete(chosenRequest, 'source'); }}
                            filter={AutoComplete.noFilter}
                            style={{ width: '100%' }}
                            listStyle={{ maxHeight: '300px', overflow: 'auto' }}
                            fullWidth
                            popoverProps={{
                                canAutoPosition: true,
                                anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                                targetOrigin: { horizontal: 'left', vertical: 'top' },
                            }}
                        />
                    </div>
                    <div className='col-xs-4'>
                        <p style={{ fontSize: '12px' }}>
                            Auto Complete only areas (Search fields are name, alt name). <br />
                            Area doesn't have country field.
                        </p>
                        <AutoComplete
                            textFieldStyle={styles.autoCompleteCSS}
                            floatingLabelText='Destination'
                            searchText={destinationObject.name}
                            dataSource={destinationItems}
                            dataSourceConfig={{ text: 'name', value: 'item' }}
                            onUpdateInput={(searchText) => { this.onUpdateInput(searchText, 'destination'); }}
                            onNewRequest={(chosenRequest) => { this.onChooseAutoComplete(chosenRequest, 'destination'); }}
                            filter={AutoComplete.noFilter}
                            style={{ width: '100%' }}
                            listStyle={{ maxHeight: '300px', overflow: 'auto' }}
                            fullWidth
                            popoverProps={{
                                canAutoPosition: true,
                                anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                                targetOrigin: { horizontal: 'left', vertical: 'top' },
                            }}
                        />
                    </div>
                    <div className='col-xs-4'>
                        <div>
                            <RaisedButton
                                primary
                                disabled={disabledBtn}
                                label='merge areas'
                                onClick={this.merge}
                            />
                        </div>

                        <div style={{ margin: '10px 0 0 0' }}>
                            <RaisedButton
                                primary
                                disabled={disabledAddAreaToArea}
                                label='add area to area'
                                onClick={this.add}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-4">
                        {
                            !sourceObject.childs || sourceObject.childs.length === 0 ? null : <MapComponent
                                coordinates={sourceObject.childs}
                                type="area"
                                loadingElement={<div style={{ height: '100%' }} />}
                                containerElement={<div style={{ height: '300px' }} />}
                                mapElement={<div style={{ height: '100%' }} />}
                                areaPolygon={sourceObject.areaCoordinates}
                            />
                        }
                        {
                            sourceObject.childs && sourceObject.childs.length === 0 ?
                                'Area doesn`t have ports'
                                :
                                ''
                        }
                    </div>
                    <div className="col-xs-4">
                        {
                            !destinationObject.childs || destinationObject.childs.length === 0 ? null : <MapComponent
                                coordinates={destinationObject.childs}
                                type="area"
                                loadingElement={<div style={{ height: '100%' }} />}
                                containerElement={<div style={{ height: '300px' }} />}
                                mapElement={<div style={{ height: '100%' }} />}
                                areaPolygon={sourceObject.areaCoordinates}
                            />
                        }

                        {
                            destinationObject.childs && destinationObject.childs.length === 0 ?
                                'Area doesn`t have ports'
                                :
                                ''
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state, {
        mergeAreas, joinAreas, addValue, disabledBtn, clearAreas, 
    }) => ({
        mergeAreas,
        joinAreas,
        addValue,
        disabledBtn,
        clearAreas,
    }),
    dispatch => bindActionCreators(
        {

        },
        dispatch,
    ),
)(MergingAreas);



// WEBPACK FOOTER //
// ./app/components/Regions/Merging/Areas.jsx